import { useEffect, useRef } from "react";

export const CustomCursor = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const move = (e) => {
      el.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
    };

    const onOver = (e) => {
      if (e.target.closest("a, button, [role='button'], input, textarea, select, label")) {
        el.classList.add("wc-cursor-hover");
      }
    };
    const onOut = (e) => {
      if (e.target.closest("a, button, [role='button'], input, textarea, select, label")) {
        el.classList.remove("wc-cursor-hover");
      }
    };

    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", onOver);
    window.addEventListener("mouseout", onOut);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", onOver);
      window.removeEventListener("mouseout", onOut);
    };
  }, []);

  return (
    <div ref={ref} className="wc-cursor" data-testid="custom-cursor" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.4" strokeLinecap="square">
        <line x1="4" y1="4" x2="20" y2="20" />
        <line x1="20" y1="4" x2="4" y2="20" />
      </svg>
    </div>
  );
};

export default CustomCursor;
